import React, { useCallback } from "react";

import { useHistory } from "react-router-dom";

import { HouseholdMember } from "@fartherfinance/frontend/api/Households/types";

import { unknownBalanceValue } from "@src/constants/unknownBalanceValue";
import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";
import Text from "@src/sharedComponents/Typography/Text";

import HouseholdMembersLink from "./HouseholdMembersLink";

interface MemberLinkToolTipProps {
  members?: HouseholdMember[];
  maxWidth?: number;
}

const MemberLinkToolTip: React.FC<MemberLinkToolTipProps> = ({
  members,
  maxWidth = 200,
}) => {
  const history = useHistory();

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      if (members && members.length > 0) {
        const firstMember = members[0];
        const location = history.location;
        history.push({
          ...location,
          pathname: `/Advisor/Clients/${firstMember.clientId}`,
        });
      }
    },
    [history, members]
  );

  if (!members || members.length === 0) {
    return <>{unknownBalanceValue}</>;
  }

  if (members.length === 1) {
    return <HouseholdMembersLink member={members[0]} />;
  }

  const tooltipContent = (
    <div>
      {members.map((member) => (
        <Text variant="body" key={member.clientId} style={{ padding: "2px 0" }}>
          <HouseholdMembersLink member={member} />
        </Text>
      ))}
    </div>
  );

  const firstMember = members[0];
  const displayText = `${firstMember.firstName ?? "Unknown"} ${
    firstMember.lastName ?? "Member"
  } +${members.length - 1} more`;

  return (
    <Tooltip tooltipText={tooltipContent}>
      <Text
        onClick={handleClick}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: `${maxWidth}px`,
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        {displayText}
      </Text>
    </Tooltip>
  );
};

export default MemberLinkToolTip;
